import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { api } from '@/lib/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          throw new Error('No session ID found');
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for session_token
        const response = await api.post('/auth/google/session', {
          session_id: sessionId
        });

        const { user } = response.data;

        // Store user data temporarily
        toast.success(`¡Bienvenido, ${user.name}!`);

        // Navigate based on role
        if (user.role === 'superadmin') {
          navigate('/superadmin', { state: { user }, replace: true });
        } else {
          navigate('/dashboard', { state: { user }, replace: true });
        }
      } catch (error) {
        console.error('Auth error:', error);
        if (error.response?.status === 403) {
          toast.error('Tu email no está autorizado. Contacta al administrador.');
        } else {
          toast.error('Error en la autenticación');
        }
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen gradient-bg flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-teal-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600">Verificando autenticación...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
